import {Component, EventEmitter, Input, Output} from '@angular/core';
import {StateService} from "../../../service/state";
import {ApiService} from "../../../service/api";
import {CheckoutComponent} from "../../../pages/checkout/checkout.component";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CartService} from "../../../service/cart";

@Component({
    selector: 'checkout-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss']
})
export class PaymentComponent {

    @Input('checkout')
    public checkout: CheckoutComponent;

    @Output('payment')
    public payment = new EventEmitter();

    public payments: any[] = [];

    private _selected_payment: any;
    get selected_payment(): any {
        return this._selected_payment;
    }

    set selected_payment(value: any) {
        this.payment.next(value);
        this._selected_payment = value;
    }

    constructor(public state: StateService, public api: ApiService, public fb: FormBuilder, public cart: CartService) {
        this.api.call('/checkout/index/payments').then((result) => {
            var p = result;
            var payments = [];
            Object.keys(p).forEach((k) => {
                p[k].key = k;
                payments.push(p[k]);
            })

            this.payments = payments;
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/components/checkout/payment/payment.component.ts